import type { Theme } from '@mui/material/styles';
import { usePageLayoutSlots } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';

const styleSheet = {
  sidebar: (theme: Theme) => ({
    background: theme.palette.common.white,
    border: '1px solid',
    borderColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    minHeight: 0,
    width: theme.layout.aside.width,
  }),
};
export default function ScheduleHeader() {
  const { pageSidebarSlot } = usePageLayoutSlots();

  if (!pageSidebarSlot) {
    return null;
  }

  return (
    <Box component="aside" sx={styleSheet.sidebar}>
      {pageSidebarSlot}
    </Box>
  );
}
